import { http } from '@/app/helpers/axios-instance';

export const registerContactMessage = (contactRequest) =>
  http.post(`/v1/support/contact`, contactRequest)
  .then(response => response.data);
